
















































import { Box, SecondaryButton, Button, Flex, BaseModal, InputError } from '../../atoms'
import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import { PasswordInputGroup } from '../../molecules'
import { mapActions } from 'vuex'
import { passwordRequired, passwordMinLength, passwordMismatch, wrongPasswordPattern } from '../../../utils/errors'
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
import { passwordPattern } from '../../../utils/validators'

import { PROFILE_MODULE, CREATE_PASSWORD } from '../../../store/modules/profile/constant'

@Component({
  components: {
    Box,
    Flex,
    SecondaryButton,
    Button,
    BaseModal,
    PasswordInputGroup,
    InputError
  },
  methods: {
    ...mapActions(PROFILE_MODULE, [CREATE_PASSWORD])
  },
  validations: {
    newPassword: {
      required,
      minLength: minLength(8),
      passwordPattern
    },
    repeatPassword: {
      required,
      sameAsPassword: sameAs('newPassword')
    }
  }
})
export default class CreatePasswordBox extends Vue {
  @Prop({ required: false, type: Array }) readonly providers!: any
  showBox = true
  modalVisible = false
  modalVisibleSuccess = false
  errorMsg = ''
  newPassword = ''
  repeatPassword = ''
  errorNewPassword = ''
  errorRepeatPassword = ''

  @Watch('providers')
  checkEmailProvider() {
    for (const q of this.providers) {
      if (q.provider == 'email') {
        this.showBox = false
      }
    }
  }

  @Watch('modalVisible')
  onModalVisibilityChange() {
    if (this.modalVisible) {
      this.$nextTick(() => {
        this.$v.$reset()
      })
    }
  }
  @Watch('newPassword')
  onPasswordChange() {
    this.errorMsg = ''
    this.$v.newPassword.$touch()
  }
  @Watch('repeatPassword')
  onRepeatPassword() {
    this.errorMsg = ''
    this.$v.repeatPassword.$touch()
  }

  onClose(): void {
    this.clearValue()
    this.modalVisible = !this.modalVisible
  }
  clearValue(): void {
    this.newPassword = ''
    this.repeatPassword = ''
  }
  onCloseSuccess(): void {
    this.modalVisibleSuccess = !this.modalVisibleSuccess
    location.reload()
  }
  get formError(): boolean {
    return this.$v.$invalid || this.errorMsg !== ''
  }

  get newPasswordError(): string {
    const { newPassword } = this.$v
    if (newPassword.$error) {
      if (!newPassword.required) {
        this.errorNewPassword = passwordRequired
        return passwordRequired
      }
      if (!newPassword.minLength) {
        this.errorNewPassword = passwordMinLength
        return passwordMinLength
      }
      if (!newPassword.passwordPattern) {
        this.errorNewPassword = wrongPasswordPattern
        return wrongPasswordPattern
      }
    }
    return ''
  }
  get repeatPasswordError(): string {
    const { repeatPassword } = this.$v
    if (repeatPassword.$error) {
      if (!repeatPassword.required) {
        this.errorRepeatPassword = passwordRequired
        return passwordRequired
      }
      if (!repeatPassword.sameAsPassword) {
        this.errorRepeatPassword = passwordMismatch
        return passwordMismatch
      }
    }
    return ''
  }
  async submitCreatePassword() {
    this.$v.$touch()
    if (!this.formError) {
      const password = {
        password: this.newPassword,
        repeat_password: this.repeatPassword
      }
      const resp = await (this as any)[CREATE_PASSWORD](password)
      if (resp.code === 200) {
        this.clearValue()
        this.modalVisible = !this.modalVisible
        this.modalVisibleSuccess = !this.modalVisibleSuccess
      } else {
        this.errorMsg = resp?.error_message
      }
    }
  }
}
